(function ($) {
  let slideBarToggle = null;

  function closeDropdown($li) {
    const $toggle = $li.find('> .nav-item__link-wrapper > .dropdown__toggle');

    $li.removeClass('opened');
    $toggle.attr('aria-expanded', 'false');
    $toggle.find('.toggle-label').text($toggle.attr('data-label-open'));
  }

  function toggleDropdown(event, $toggle) {
    event.preventDefault();
    event.stopPropagation();

    const $li = $toggle.closest('.dropdown');

    if ($li.hasClass('opened')) {
      closeDropdown($li);
    } else {
      $li.addClass('opened');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
    }
  }

  function prepareDropdownForNav($nav) {
    ///// INIT SLIDER POSITION /////
    $nav.find('.active').each(function () {
      const $li = $(this);
      $li.addClass('opened');

      const $toggle = $li.find('> .nav-item__link-wrapper > .dropdown__toggle');
      $toggle.attr('aria-expanded', 'true');
      $toggle.find('.toggle-label').text($toggle.attr('data-label-close'));
    });

    ///// INIT EVENTS /////
    $nav.find('.dropdown__toggle').on('click', function (event) {
      toggleDropdown(event, $(this));
    });
    // Make the whole row toggle the dropdown (link text included), not just the small
    // toggle button, for every nav item that has one (heading or real link alike).
    $nav
      .find('.nav-item__link-wrapper')
      .filter(function () {
        return $(this).children('.dropdown__toggle').length > 0;
      })
      .on('click', function (event) {
        // The toggle button already has its own handler above; don't double-handle its clicks.
        if ($(event.target).closest('.dropdown__toggle').length) {
          return;
        }

        toggleDropdown(event, $(this).children('.dropdown__toggle'));
      });
    $nav.find('.dropdown__subnav-back-cta').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      closeDropdown($(this).closest('.dropdown'));
    });
  }

  function closeSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open');
    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
  }

  function tryClosingSlidebarMenu(event) {
    // Keyboard
    if ('undefined' !== typeof event.keyCode) {
      // ESCAPE
      if (27 === event.keyCode) {
        $('.vtx-burger-container').focus();
        closeSlidebarMenu();
      }
    }
    // Click
    else if (!$(event.target).closest('#mobile-menu-wrapper').length) {
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
  }

  function initMenuMobile() {
    slideBarToggle = $('.vtx-burger-container');

    const $mobileMenu = $('#mobile-menu');

    slideBarToggle.on('click', function (event) {
      event.stopPropagation();

      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });

    prepareDropdownForNav($mobileMenu.find('.nav-mobile'));
  }

  $(document).ready(function () {
    initMenuMobile();
  });
})(jQuery);
